var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn logo-img",attrs:{"id":"XFINITY","name":"XFINITY","aria-label":_vm.$t('menuLabel'),"data-vcode":"MENU"}},[_c('img',{attrs:{"src":_vm.imgLogo,"alt":"","role":"img","aria-hidden":"true"}}),_c('label',[_vm._v(_vm._s(_vm.$t('menuButton')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }